export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "pooja", label: "Pooja Essentials" },
  { id: "premium", label: "Premium Pooja Essentials" },
  { id: "sacred", label: "Sacred Essentials" },
  { id: "fragrance", label: "Fragrance & Rituals" },
  { id: "kits", label: "Pooja Kits" },
  { id: "learning", label: "Spiritual Learning" },
];

export const getCategoryLabel = (id) => {
  const c = CATEGORIES.find((x) => x.id === id);
  return c ? c.label : id;
};

export const PRODUCTS = [
  {
    slug: "pure-kapoor",
    name: "Camphor (Kapoor)",
    category: "pooja",
    tagline: "Crystalline. Clean burning.",
    short: "Pure camphor for daily pooja, aarti, havan, and spiritual rituals.",
    image: "/products/pure-kapoor.jpg",
    sizes: ["25g", "50g", "100g"],
    packaging: "Premium Jar",
    benefits: ["Clean burning, no residue", "Strong aromatic fragrance", "Slow, steady flame", "Hand-sealed for purity"],
    howTo: ["Place a tablet on the aarti plate or kapoor stand.", "Light with a long match or wick.", "Hold steady during aarti and allow it to burn fully."],
    specs: { "Available Sizes": "25g · 50g · 100g", "Packaging": "Premium Jar", "Form": "Tablets", "Country Of Origin": "India" },
    faq: [{ q: "Is this synthetic or natural?", a: "Refined pure camphor of premium grade, suitable for ritual use." }],
  },
  {
    slug: "bhimseni-kapoor",
    name: "Bheemseni Camphor",
    category: "premium",
    tagline: "Traditional. Natural. Aromatic.",
    short: "Natural Bheemseni Kapoor known for its purity, strong aroma, and traditional spiritual significance.",
    image: "/products/bhimseni-kapoor.jpg",
    sizes: ["25g", "50g", "100g"],
    packaging: "Premium Jar",
    benefits: ["Long lasting aroma", "Cooler, gentle flame", "Authentic Bheemseni crystals", "Traditional grade"],
    howTo: ["Place small crystals on the aarti plate.", "Light gently with a long match.", "Use during evening aarti for best aroma."],
    specs: { "Available Sizes": "25g · 50g · 100g", "Packaging": "Premium Jar", "Form": "Natural crystals", "Country Of Origin": "India" },
    faq: [{ q: "How is it different from regular kapoor?", a: "Bheemseni is the natural, traditional grade with a distinct, lingering fragrance." }],
  },
  {
    slug: "cotton-wicks",
    name: "Cotton Wicks",
    category: "pooja",
    tagline: "Hand-rolled. Long lasting.",
    short: "Premium cotton wicks for daily diya lighting and religious ceremonies.",
    image: "/products/cotton-wicks.jpg",
    sizes: ["51 Pieces", "101 Pieces"],
    packaging: "Pouch Pack",
    benefits: ["100% pure cotton", "Hand-rolled", "Even, smokeless flame", "Multipurpose for diya & deepak"],
    howTo: ["Dip in ghee or puja oil.", "Place in diya, light from the tip.", "Trim wick edge for cleaner flame."],
    specs: { "Available Sizes": "51 · 101 Pieces", "Packaging": "Pouch Pack", "Material": "Pure cotton", "Country Of Origin": "India" },
    faq: [{ q: "Can it be used with oil?", a: "Yes, works beautifully with both ghee and puja oil." }],
  },
  {
    slug: "ghee-cotton-wicks",
    name: "Ghee Cotton Wicks",
    category: "premium",
    tagline: "Ready-to-use. Long burn.",
    short: "Ready-to-use ghee-infused cotton wicks for longer and cleaner diya lighting.",
    image: "/products/ghee-cotton-wicks.jpg",
    sizes: ["21 Pieces", "51 Pieces"],
    packaging: "Pouch Pack",
    benefits: ["Pre-infused with pure ghee", "Cleaner, brighter flame", "Longer burn time", "No prep needed — light & use"],
    howTo: ["Place the wick directly in a clean diya.", "Light the tip — no extra oil needed.", "Burns steadily for an extended duration."],
    specs: { "Available Sizes": "21 · 51 Pieces", "Packaging": "Pouch Pack", "Material": "Cotton + pure ghee", "Country Of Origin": "India" },
    faq: [{ q: "Do I still need to add ghee or oil?", a: "No — these wicks are pre-soaked in pure ghee and ready to light." }],
  },
  {
    slug: "kumkum",
    name: "Kumkum",
    category: "pooja",
    tagline: "Vibrant. Pure. Auspicious.",
    short: "Traditional kumkum for pooja rituals, tilak application, and religious ceremonies.",
    image: "/products/kumkum.jpg",
    sizes: ["25g", "50g", "100g"],
    packaging: "Premium Jar",
    benefits: ["Vivid, lasting colour", "Fine, soft texture", "Skin-friendly", "Premium ritual grade"],
    howTo: ["Apply small quantity on forehead for tilak.", "Use a pinch for archana on murti.", "Store dry, away from moisture."],
    specs: { "Available Sizes": "25g · 50g · 100g", "Packaging": "Premium Jar", "Form": "Powder", "Country Of Origin": "India" },
    faq: [{ q: "Is it tested for skin safety?", a: "Yes, our kumkum is dermatologically friendly and ritual-grade." }],
  },
  {
    slug: "kalava",
    name: "Kalava",
    category: "pooja",
    tagline: "Sacred thread of trust.",
    short: "Sacred thread used during Hindu rituals, pujas, havans, and religious ceremonies.",
    image: "/products/kalava.jpg",
    sizes: ["1 Piece", "3 Pieces", "5 Pieces"],
    packaging: "Roll Pack",
    benefits: ["Pure cotton thread", "Vivid traditional dyes", "Strong, knottable weave", "Ideal for puja and sankalp"],
    howTo: ["Tie around the wrist during puja.", "Use during havan and sankalp.", "Replace on auspicious days."],
    specs: { "Available Sizes": "1 · 3 · 5 Pieces", "Packaging": "Roll Pack", "Material": "Cotton", "Country Of Origin": "India" },
    faq: [{ q: "Which wrist should it be tied on?", a: "Right hand for men & unmarried women; left for married women, per tradition." }],
  },
  {
    slug: "orange-sindoor",
    name: "Orange Sindoor",
    category: "pooja",
    tagline: "Vivid. Sacred. Traditional.",
    short: "Premium orange sindoor for pooja, tilak and traditional applications.",
    image: "/products/orange-sindoor.jpg",
    sizes: ["25g", "50g", "100g"],
    packaging: "Premium Jar",
    benefits: ["Vivid orange hue", "Fine, uniform texture", "Skin-friendly formulation", "Premium ritual grade"],
    howTo: ["Take a small pinch for tilak.", "Offer during archana on murti.", "Store dry, sealed."],
    specs: { "Available Sizes": "25g · 50g · 100g", "Packaging": "Premium Jar", "Form": "Powder", "Country Of Origin": "India" },
    faq: [{ q: "Is it safe on skin?", a: "Yes — dermatologically friendly, ritual-grade formulation." }],
  },
  {
    slug: "ashtagandh-powder",
    name: "Ashtagandh Powder",
    category: "pooja",
    tagline: "Eight sacred herbs. One tradition.",
    short: "Traditional blend of eight aromatic herbs used in pooja, tilak and havan.",
    image: "/products/ashtagandh-powder.jpg",
    sizes: ["25g", "50g", "100g"],
    packaging: "Premium Jar",
    benefits: ["Blend of 8 traditional herbs", "Rich, grounding aroma", "Fine, mixable texture", "Authentic ritual grade"],
    howTo: ["Mix a pinch with water for tilak.", "Offer during archana.", "Use in havan sequences as prescribed."],
    specs: { "Available Sizes": "25g · 50g · 100g", "Packaging": "Premium Jar", "Ingredients": "8 traditional herbs", "Country Of Origin": "India" },
    faq: [{ q: "Which 8 herbs are used?", a: "A traditional blend including chandan, kesar, kastoori and others per shastra." }],
  },
  {
    slug: "sambrani-cups",
    name: "Sambrani Cups",
    category: "fragrance",
    tagline: "Divine smoke. Instant ritual.",
    short: "Traditional sambrani cups — light, place, and fill the room with a divine, calming aroma.",
    image: "/products/sambrani-cups.jpg",
    sizes: ["Pack of 12 Cups"],
    packaging: "Premium Carton Box",
    benefits: ["Traditional resin blend", "No mess — pre-formed cup", "Long-lasting aroma", "Ideal for evening sandhya"],
    howTo: ["Light the top of the cup until ember forms.", "Place on a heat-safe stand or plate.", "Allow smoke to fill and purify the space."],
    specs: { "Available Sizes": "Pack of 12 Cups", "Packaging": "Premium Carton Box", "Burn Time": "15-20 mins per cup", "Country Of Origin": "India" },
    faq: [{ q: "Is it safe indoors?", a: "Yes, in well-ventilated rooms. Always use a heat-safe stand." }],
  },
  {
    slug: "attar-spray",
    name: "Attar Spray",
    category: "fragrance",
    tagline: "Sacred fragrance. Effortless.",
    short: "Traditional attar in a modern spray format — for daily worship, meditation and personal use.",
    image: "/products/attar-spray.jpg",
    sizes: ["50 ml"],
    packaging: "Premium Glass Bottle",
    benefits: ["Traditional attar blend", "Alcohol-free formulation", "Long-lasting fragrance", "Sacred, calming aroma"],
    howTo: ["Spray lightly on the wrist or clothing.", "Use on puja fabric before rituals.", "A little goes a long way."],
    specs: { "Available Sizes": "50 ml", "Packaging": "Premium Glass Bottle", "Form": "Spray", "Country Of Origin": "India" },
    faq: [{ q: "Is it alcohol-based?", a: "No — traditional attar formulation, alcohol-free." }],
  },
  {
    slug: "attar-roll-on",
    name: "Attar Roll On",
    category: "fragrance",
    tagline: "Compact. Concentrated. Sacred.",
    short: "Concentrated attar in a travel-friendly roll-on — a drop is enough for daily worship.",
    image: "/products/attar-roll-on.jpg",
    sizes: ["8 ml"],
    packaging: "Roll-On Bottle",
    benefits: ["Concentrated formulation", "Travel-friendly", "Alcohol-free", "Long-lasting fragrance"],
    howTo: ["Roll a drop on wrist or clothing.", "Use on puja fabric before rituals.", "One drop lasts hours."],
    specs: { "Available Sizes": "8 ml", "Packaging": "Roll-On Bottle", "Form": "Roll-on", "Country Of Origin": "India" },
    faq: [{ q: "How long does one bottle last?", a: "A single 8ml bottle typically lasts 4-6 weeks with daily use." }],
  },
  {
    slug: "chandan-tilak-paste",
    name: "Chandan Tilak Paste",
    category: "sacred",
    tagline: "Cool. Calm. Centering.",
    short: "Premium sandalwood tilak paste for pooja, meditation, and daily spiritual practices.",
    image: "/products/chandan-tilak-paste.jpg",
    sizes: ["25g", "50g", "100g"],
    packaging: "Premium Jar",
    benefits: ["Authentic sandalwood", "Smooth, cooling texture", "Lingering fragrance", "Skin-friendly"],
    howTo: ["Take a small amount on the fingertip.", "Apply gently on forehead for tilak.", "Use during morning sandhya and meditation."],
    specs: { "Available Sizes": "25g · 50g · 100g", "Packaging": "Premium Jar", "Form": "Paste", "Country Of Origin": "India" },
    faq: [{ q: "Is this pure chandan?", a: "Crafted from authentic sandalwood, no synthetic fillers." }],
  },
  {
    slug: "havan-samagri",
    name: "Havan Samagri",
    category: "pooja",
    tagline: "Twenty-one herbs. One tradition.",
    short: "A premium blend of herbs, resins and woods for traditional havan and yagya.",
    image: "/products/havan-samagri.jpg",
    sizes: ["250 g"],
    packaging: "Premium Carton Box",
    benefits: ["21+ traditional ingredients", "Hand-mixed in small batches", "Authentic aromatic profile", "Ritual ready"],
    howTo: ["Prepare havan kund with mango wood & ghee.", "Offer a pinch with each mantra.", "Conclude with purna ahuti."],
    specs: { "Available Sizes": "250 g", "Packaging": "Premium Carton Box", "Ingredients": "21+ herbs, resins & woods", "Country Of Origin": "India" },
    faq: [{ q: "Suitable for griha shanti havan?", a: "Yes, this is our standard blend for all major havans." }],
  },
  {
    slug: "gangajal",
    name: "Gangajal",
    category: "sacred",
    tagline: "Holy. Pure. Sacred.",
    short: "Holy Ganga water for daily worship, purification rituals, and spiritual ceremonies.",
    image: "/products/gangajal.jpg",
    sizes: ["250 ml", "500 ml"],
    packaging: "Tamper-Sealed Bottle",
    benefits: ["Sourced from the sacred Ganga", "Tamper-sealed for purity", "Long shelf life", "Premium bottle"],
    howTo: ["Use a few drops on the puja thali for sanctification.", "Sprinkle during sankalp and havan.", "Add to abhishek water for added sanctity."],
    specs: { "Available Sizes": "250 ml · 500 ml", "Packaging": "Tamper-Sealed Bottle", "Source": "River Ganga", "Country Of Origin": "India" },
    faq: [{ q: "How is purity ensured?", a: "Each bottle is filled at source, filtered, and tamper-sealed for authenticity." }],
  },
  {
    slug: "til-oil",
    name: "Til Oil",
    category: "sacred",
    tagline: "Traditional. Pure. Sacred.",
    short: "Cold-pressed til oil, traditionally used in Shani puja, deepak lighting and abhishek.",
    image: "/products/til-oil.jpg",
    sizes: ["250 ml", "500 ml"],
    packaging: "Premium Bottle",
    benefits: ["Cold-pressed", "Traditional ritual grade", "Rich, steady flame in diya", "Ideal for Shani puja"],
    howTo: ["Fill diya to two-thirds with til oil.", "Dip wick fully before lighting.", "Use during Saturday puja and abhishek."],
    specs: { "Available Sizes": "250 ml · 500 ml", "Packaging": "Premium Bottle", "Type": "Cold-pressed sesame oil", "Country Of Origin": "India" },
    faq: [{ q: "Is this edible?", a: "No — this til oil is crafted specifically for ritual use." }],
  },
  {
    slug: "dhoop-sticks",
    name: "Dhoop Sticks",
    category: "fragrance",
    tagline: "Earthy. Resinous. Grounding.",
    short: "Traditional dhoop sticks that create a divine and peaceful atmosphere during prayers.",
    image: "/products/dhoop-sticks.jpg",
    sizes: ["51 Pieces", "101 Pieces"],
    packaging: "Premium Carton Box",
    benefits: ["Hand-rolled", "Long lingering aroma", "Traditional herbal blend", "Divine, calming atmosphere"],
    howTo: ["Light the tip until ember forms.", "Place on a heat-safe stand.", "Allow smoke to settle the space."],
    specs: { "Available Sizes": "51 · 101 Pieces", "Packaging": "Premium Carton Box", "Burn Time": "30 mins per stick", "Country Of Origin": "India" },
    faq: [{ q: "Is it safe indoors?", a: "Yes, in well-ventilated rooms. Always use a heat-safe stand." }],
  },
  {
    slug: "agarbatti",
    name: "Agarbatti",
    category: "fragrance",
    tagline: "Fragrance of devotion.",
    short: "Premium agarbatti crafted with traditional resins and florals for daily worship.",
    image: "/products/agarbatti.jpg",
    sizes: ["51 Pieces", "101 Pieces"],
    packaging: "Premium Carton Box",
    benefits: ["Slow, even burn", "Rich, lingering aroma", "Natural ingredients", "Traditional bamboo core"],
    howTo: ["Light the tip, blow out flame.", "Place in an agarbatti stand.", "Allow to burn in a ventilated space."],
    specs: { "Available Sizes": "51 · 101 Pieces", "Packaging": "Premium Carton Box", "Burn Time": "45 mins per stick", "Country Of Origin": "India" },
    faq: [{ q: "Are these charcoal or bamboo based?", a: "Premium bamboo core with natural masala blend." }],
  },
  {
    slug: "navgrah-kit",
    name: "Navgrah Kit",
    category: "pooja",
    tagline: "Nine planets. One tradition.",
    short: "Pack of 9 sambrani cups — one for each of the nine grahas — for Navgrah puja and shanti.",
    image: "/products/navgrah-kit.jpg",
    sizes: ["Pack of 9 Cups"],
    packaging: "Premium Carton Box",
    benefits: ["9 sambrani cups — one per graha", "Traditional resin blend", "Ready-to-use for Navgrah puja", "Ideal for shanti rituals"],
    howTo: ["Place one cup for each of the 9 grahas.", "Light each cup during the respective mantra.", "Allow the divine smoke to fill the space."],
    specs: { "Available Sizes": "Pack of 9 Cups", "Packaging": "Premium Carton Box", "Country Of Origin": "India" },
    faq: [{ q: "Is a guide included?", a: "Refer to our Pooja Guide Book for the full Navgrah puja sequence." }],
  },
  {
    slug: "hanuman-pooja-kit",
    name: "Hanuman Pooja Kit",
    category: "kits",
    tagline: "Strength. Devotion. Discipline.",
    short: "Complete pooja samagri in one kit — curated for Hanuman puja, Chalisa paath and Tuesday rituals.",
    image: "/products/hanuman-kit.jpg",
    sizes: ["One-Box Kit"],
    packaging: "Premium Kit Box",
    benefits: ["Complete pooja samagri in one box", "Premium ingredients, correct ratios", "Includes step-by-step guide"],
    howTo: ["Lay out samagri on the puja chowki.", "Begin with sankalp and deepak prajwalan.", "Follow the guide book paath in order."],
    specs: { "Format": "One-Box Kit", "Packaging": "Premium Kit Box", "Country Of Origin": "India" },
    faq: [{ q: "Does it include a guide book?", a: "Yes — a step-by-step Hanuman puja guide is included." }],
  },
  {
    slug: "shani-pooja-kit",
    name: "Shani Pooja Kit",
    category: "kits",
    tagline: "Patience. Discipline. Justice.",
    short: "Complete pooja samagri in one kit — curated for Shani Dev puja and Saturday rituals.",
    image: "/products/shani-kit.jpg",
    sizes: ["One-Box Kit"],
    packaging: "Premium Kit Box",
    benefits: ["Saturday-ready in one box", "Authentic mustard oil & til", "Includes paath guide"],
    howTo: ["Bathe Shani idol with mustard oil.", "Light iron diya with til oil.", "Recite mantras as per guide."],
    specs: { "Format": "One-Box Kit", "Packaging": "Premium Kit Box", "Country Of Origin": "India" },
    faq: [{ q: "Does it include a guide book?", a: "Yes — a step-by-step Shani puja guide is included." }],
  },
  {
    slug: "shivji-pooja-kit",
    name: "Shivji Pooja Kit",
    category: "kits",
    tagline: "Stillness. Power. Grace.",
    short: "Complete pooja samagri in one kit — curated for Shivji abhishek, Mondays and Mahashivratri.",
    image: "/products/shivji-kit.jpg",
    sizes: ["One-Box Kit"],
    packaging: "Premium Kit Box",
    benefits: ["Abhishek-ready samagri", "Authentic bhasma & chandan", "Includes step-by-step guide"],
    howTo: ["Place Shivling on a clean thali.", "Offer abhishek as per guide.", "Conclude with aarti & kapoor."],
    specs: { "Format": "One-Box Kit", "Packaging": "Premium Kit Box", "Country Of Origin": "India" },
    faq: [{ q: "Does it include a guide book?", a: "Yes — a step-by-step Shivji puja guide is included." }],
  },
  {
    slug: "griha-pravesh-kit",
    name: "Griha Pravesh Kit",
    category: "kits",
    tagline: "A blessing for new beginnings.",
    short: "Complete pooja samagri in one kit — curated for griha pravesh, vastu shanti and new-home rituals.",
    image: "/products/griha-pravesh-kit.jpg",
    sizes: ["One-Box Kit"],
    packaging: "Premium Kit Box",
    benefits: ["Vastu-correct sequencing", "Premium toran & kalash", "Includes step-by-step guide"],
    howTo: ["Set kalash at the entrance.", "Tie mango-leaf toran on the door.", "Perform havan as per guide."],
    specs: { "Format": "One-Box Kit", "Packaging": "Premium Kit Box", "Country Of Origin": "India" },
    faq: [{ q: "Does it include a guide book?", a: "Yes — a step-by-step Griha Pravesh guide is included." }],
  },
  {
    slug: "lakshmi-pooja-kit",
    name: "Lakshmi Pooja Kit",
    category: "kits",
    tagline: "Prosperity. Abundance. Grace.",
    short: "Complete pooja samagri in one kit — curated for Lakshmi puja, Diwali and Fridays.",
    image: "/products/lakshmi-kit.jpg",
    sizes: ["One-Box Kit"],
    packaging: "Premium Kit Box",
    benefits: ["Diwali-ready in one box", "Premium samagri, correct ratios", "Includes paath guide"],
    howTo: ["Set up chowki with Lakshmi idol.", "Light akhand jyot at sankalp.", "Follow paath as per the guide."],
    specs: { "Format": "One-Box Kit", "Packaging": "Premium Kit Box", "Country Of Origin": "India" },
    faq: [{ q: "Does it include a guide book?", a: "Yes — a step-by-step Lakshmi puja guide is included." }],
  },
  {
    slug: "pooja-guide-books",
    name: "Pooja Guide Books",
    category: "learning",
    tagline: "Rituals, explained.",
    short: "Step-by-step guides for daily puja, aarti, mantras, vrat rituals, festival worship and modern household practices.",
    image: "/products/pooja-guide-books.jpg",
    sizes: ["Pocket Edition", "Standard Edition", "Premium Edition"],
    packaging: "Printed Booklet",
    features: ["Daily Pooja Guide", "Essential Mantras", "Aarti Collection", "Festival Rituals", "Beginner Friendly", "Easy-to-Follow Instructions"],
    benefits: ["Daily Pooja Guide", "Essential Mantras", "Aarti Collection", "Festival Rituals", "Beginner Friendly", "Easy-to-Follow Instructions"],
    howTo: ["Read the sankalp at the beginning.", "Follow the steps in order for each ritual.", "Conclude with aarti & prasad."],
    specs: { "Available Formats": "Pocket · Standard · Premium Edition", "Packaging": "Printed Booklet", "Language": "Hindi + English", "Country Of Origin": "India" },
    faq: [
      { q: "Is the language easy to follow?", a: "Yes — written for modern households with Hindi & English transliteration." },
      { q: "What's the difference between editions?", a: "Pocket is travel-friendly, Standard is full-length, Premium is hardbound with extended chapters." },
    ],
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const getRelated = (slug) => {
  const cur = getProduct(slug);
  if (!cur) return [];
  return PRODUCTS.filter((p) => p.slug !== slug && p.category === cur.category).slice(0, 4);
};
